import {Component, OnDestroy, OnInit} from '@angular/core';
import {RequestQueueService} from "../../services/request-queue.service";
import {ReportUtils} from "../../libraries/report-utils";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-report-queue-loader',
  templateUrl: './report-queue-loader.component.html',
  styleUrls: ['./report-queue-loader.component.scss']
})
export class ReportQueueLoaderComponent implements OnInit, OnDestroy {

  public total: number = 0;
  public done = 0;

  private queueChangedSubs: Subscription;
  private processedChangedSubs: Subscription;

  constructor(
    private readonly requestQueueS: RequestQueueService
  ) { }

  ngOnInit(): void {
    this.queueChangedSubs = this.requestQueueS.queueChangedE.subscribe(newVal => {
      this.total = newVal;
    });
    this.processedChangedSubs = this.requestQueueS.processedChangedE.subscribe(newVal => {
      this.done = newVal;
    });
  }

  ngOnDestroy(): void {
    ReportUtils.unsubscribe(this.queueChangedSubs);
    ReportUtils.unsubscribe(this.processedChangedSubs);
  }
}
